import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React from 'react';

import Hubspot from './Hubspot';

import './App.scss';

const AppWrapper = ({ children, subPage }) => (
  <main className={subPage ? 'sub' : ''}>
    <header>
      <svg
        viewBox='0 0 124.2 26.41'
        xmlns='http://www.w3.org/2000/svg'
      >
        <ellipse
          cx='15.64'
          cy='15.52'
          rx='10.61'
          ry='10.9'
          fill='#ff563f'
        />
        <path
          fill='#0c0c0c'
          d='M4.97,17.01c3.32,3.32,8.72,3.32,12.04,0,3.32-3.32,3.32-8.72,0-12.04-3.32-3.32-8.72-3.32-12.04,0-3.32,3.32-3.32,8.72,0,12.04ZM18.76,18.76c-4.29,4.29-11.25,4.29-15.55,0C-1.07,14.47-1.07,7.51,3.22,3.22,7.51-1.07,14.47-1.07,18.76,3.22c4.29,4.29,4.29,11.25,0,15.55ZM34,21.64v-12.42h2.55v1.46h.4c.24-.44.61-.82,1.13-1.16.52-.34,1.23-.5,2.12-.5s1.66.19,2.22.58c.57.37,1,.85,1.29,1.44h.4c.29-.57.7-1.05,1.23-1.44.55-.39,1.34-.58,2.34-.58.81,0,1.52.17,2.14.5.62.32,1.12.81,1.49,1.46.37.64.55,1.44.55,2.39v8.27h-2.6v-8.06c0-.76-.21-1.34-.63-1.74-.4-.42-.98-.63-1.74-.63-.81,0-1.45.26-1.94.78-.49.52-.73,1.27-.73,2.24v7.41h-2.6v-8.06c0-.76-.21-1.34-.63-1.74-.4-.42-.98-.63-1.74-.63-.81,0-1.45.26-1.94.78-.49.52-.73,1.27-.73,2.24v7.41h-2.6ZM59.46,22c-.89,0-1.69-.15-2.39-.45-.69-.3-1.24-.75-1.66-1.34-.4-.59-.6-1.3-.6-2.14s.2-1.56.6-2.12c.42-.57.98-1,1.69-1.29.72-.29,1.54-.43,2.44-.43h3.78v-.81c0-.72-.22-1.3-.66-1.74-.44-.44-1.11-.66-2.02-.66s-1.57.21-2.04.63c-.47.42-.78.97-.93,1.64l-2.42-.78c.2-.67.52-1.28.96-1.81.45-.55,1.05-1,1.79-1.34.74-.34,1.63-.5,2.67-.5,1.61,0,2.88.41,3.81,1.23.92.82,1.39,1.99,1.39,3.5v5.12c0,.5.24.76.71.76h1.06v2.17h-1.94c-.59,0-1.07-.15-1.44-.45-.37-.3-.55-.71-.55-1.23v-.08h-.38c-.13.25-.34.55-.6.88-.27.34-.66.63-1.18.88-.52.24-1.21.35-2.07.35ZM59.84,19.85c1.04,0,1.88-.29,2.52-.88.64-.6.96-1.43.96-2.47v-.25h-3.63c-.69,0-1.24.15-1.66.45-.42.29-.63.71-.63,1.29s.22,1.02.66,1.36c.44.34,1.03.5,1.79.5ZM70.15,21.64v-12.42h2.55v1.46h.4c.2-.52.52-.9.96-1.13.45-.25,1.01-.38,1.66-.38h1.49v2.34h-1.59c-.84,0-1.53.24-2.07.71-.54.45-.81,1.16-.81,2.12v7.31h-2.6ZM84.56,21.64c-.76,0-1.36-.23-1.81-.68-.44-.45-.66-1.06-.66-1.81v-7.74h-3.43v-2.19h3.43v-4.11h2.6v4.11h3.7v2.19h-3.7v7.28c0,.5.24.76.71.76h2.6v2.19h-3.43ZM91.44,21.64v-12.42h2.6v12.42h-2.6ZM92.75,7.53c-.5,0-.93-.16-1.29-.48-.34-.34-.5-.76-.5-1.29s.17-.94.5-1.26c.35-.34.78-.5,1.29-.5s.95.17,1.29.5c.34.32.5.74.5,1.26s-.17.95-.5,1.29c-.34.32-.76.48-1.29.48ZM101.74,22c-.89,0-1.69-.15-2.39-.45-.69-.3-1.24-.75-1.66-1.34-.4-.59-.6-1.3-.6-2.14s.2-1.56.6-2.12c.42-.57.98-1,1.69-1.29.72-.29,1.54-.43,2.44-.43h3.78v-.81c0-.72-.22-1.3-.65-1.74-.44-.44-1.11-.66-2.02-.66s-1.57.21-2.04.63c-.47.42-.78.97-.93,1.64l-2.42-.78c.2-.67.52-1.28.96-1.81.45-.55,1.05-1,1.79-1.34.74-.34,1.63-.5,2.67-.5,1.61,0,2.88.41,3.81,1.23.92.82,1.39,1.99,1.39,3.5v5.12c0,.5.24.76.71.76h1.06v2.17h-1.94c-.59,0-1.07-.15-1.44-.45-.37-.3-.55-.71-.55-1.23v-.08h-.38c-.13.25-.34.55-.61.88-.27.34-.66.63-1.18.88-.52.24-1.21.35-2.07.35ZM102.12,19.85c1.04,0,1.88-.29,2.52-.88.64-.6.96-1.43.96-2.47v-.25h-3.63c-.69,0-1.24.15-1.66.45-.42.29-.63.71-.63,1.29s.22,1.02.66,1.36c.44.34,1.03.5,1.79.5ZM112.43,21.64v-12.42h2.54v1.86h.4c.24-.5.65-.97,1.26-1.41.6-.44,1.5-.66,2.7-.66.94,0,1.77.21,2.49.63.74.42,1.32,1.02,1.74,1.79.42.76.63,1.67.63,2.75v7.46h-2.6v-7.26c0-1.08-.27-1.86-.81-2.37-.54-.52-1.28-.78-2.22-.78-1.08,0-1.94.35-2.6,1.06-.64.71-.96,1.73-.96,3.07v6.27h-2.6Z'
        />
      </svg>
    </header>
    <section>
      {children}
    </section>
  </main>
);

const RedirectWithDelay = ({ url }) => {
  window.location.href = url;
  return null;
};

function App() {
  return (
    <Router>
      <Routes>
        {[
          {
            path: '/30',
            redirect: 'https://calendly.com/d/zy2-ccn-g8x/30-minute-chat-with-founders',
          },
          {
            path: '/60',
            redirect: 'https://calendly.com/d/z99-54z-dp9/1-hour-chat-with-founders',
          },
          {
            path: '/',
            children: (
              <div className='main-buttons'>
                <a href='https://calendly.com/d/zy2-ccn-g8x/30-minute-chat-with-founders'>
                  Book a 30-minute meeting
                </a>
                <a href='https://calendly.com/d/z99-54z-dp9/1-hour-chat-with-founders'>
                  Book a 60-minute meeting
                </a>
              </div>
            )
          },
          {
            path: '/get-started',
            children: (
              <Hubspot
                link='https://meetings.hubspot.com/etan-ginsberg/martian-onboarding-with-founders?embed=true'
              />
            )
          },
          {
            path: '/enterprise',
            children: (
              <Hubspot
                link='https://meetings.hubspot.com/etan-ginsberg/enterprise-sales-website-inbound?embed=true'
              />
            )
          },
          {
            path: '/chat-with-founders',
            children: (
              <Hubspot
                link='https://meetings.hubspot.com/etan-ginsberg/exploratory-call?embed=true'
              />
            )
          },
        ].map(route => (
          <Route
            path={route.path}
            key={route.path}
            element={route.redirect ? (
              <RedirectWithDelay url='https://calendly.com/d/zy2-ccn-g8x/30-minute-chat-with-founders' />
            ) : (
              <AppWrapper subPage={route.path !== '/'}>
                {route.children}
              </AppWrapper>
            )}
          />
        ))}
      </Routes>
    </Router>
  );
}

export default App;
